import { render, staticRenderFns } from "./historyTab.vue?vue&type=template&id=5c46bd66&scoped=true&"
import script from "./historyTab.vue?vue&type=script&lang=js&"
export * from "./historyTab.vue?vue&type=script&lang=js&"
import style0 from "./historyTab.vue?vue&type=style&index=0&id=5c46bd66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46bd66",
  null
  
)

export default component.exports